import script from "./DrawerCustomer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerCustomer.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerCustomer.vue?vue&type=style&index=0&id=398d5dcc&scoped=true&lang=css"
import "./DrawerCustomer.vue?vue&type=style&index=1&id=398d5dcc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398d5dcc"]])

export default __exports__